import * as React from 'react';

export const LazyCapacityNOKExclusion = React.lazy(() => import('./component'));
